import styled from "styled-components";


export const Container = styled.section`
  margin-top: 12rem;
  
  h2{
    text-align: left;
    font-size: 3rem;
    margin-bottom: 2rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .projects{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: 2.5rem;
    padding: 1rem;
    overflow: hidden;

    .project{
      padding: 2.5rem 2rem;
      background: linear-gradient(145deg, 
        rgba(26, 26, 46, 0.9) 0%, 
        rgba(22, 33, 62, 0.95) 50%,
        rgba(26, 26, 46, 0.9) 100%
      );
      border: 1px solid transparent;
      border-radius: 2rem;
      transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      display: flex;
      flex-direction: column;
      height: 100%;
      color: #FFF;
      backdrop-filter: blur(20px);
      position: relative;
      overflow: hidden;

      /* Gradient border effect */
      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        border-radius: 2rem;
        padding: 1px;
        background: linear-gradient(135deg, 
          rgba(102, 126, 234, 0.5) 0%, 
          rgba(118, 75, 162, 0.3) 50%, 
          rgba(240, 147, 251, 0.5) 100%
        );
        -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
        -webkit-mask-composite: xor;
        mask-composite: exclude;
        pointer-events: none;
      }

      /* Animated glow effect */
      &::after {
        content: '';
        position: absolute;
        top: -50%;
        left: -50%;
        width: 200%;
        height: 200%;
        background: radial-gradient(
          ellipse at center,
          rgba(102, 126, 234, 0.15) 0%,
          transparent 70%
        );
        opacity: 0;
        transition: opacity 0.4s ease;
        pointer-events: none;
      }

      &.featured {
        background: linear-gradient(145deg, 
          rgba(102, 126, 234, 0.12) 0%, 
          rgba(26, 26, 46, 0.95) 30%,
          rgba(118, 75, 162, 0.08) 70%,
          rgba(22, 33, 62, 0.95) 100%
        );
        
        &::before {
          background: linear-gradient(135deg, 
            rgba(102, 126, 234, 0.8) 0%, 
            rgba(118, 75, 162, 0.6) 50%, 
            rgba(240, 147, 251, 0.8) 100%
          );
        }
        
        .featured-badge {
          position: absolute;
          top: -1px;
          left: 20px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
          padding: 0.6rem 1.4rem;
          border-radius: 0 0 1.2rem 1.2rem;
          font-size: 1.1rem;
          font-weight: 600;
          color: white;
          box-shadow: 
            0 4px 20px rgba(102, 126, 234, 0.5),
            0 0 40px rgba(240, 147, 251, 0.2);
          z-index: 2;
        }
      }

      &:hover{
        transform: translateY(-8px) scale(1.02);
        box-shadow: 
          0 25px 50px rgba(102, 126, 234, 0.25),
          0 0 80px rgba(118, 75, 162, 0.15),
          inset 0 0 60px rgba(102, 126, 234, 0.05);

        &::before {
          background: linear-gradient(135deg, 
            rgba(102, 126, 234, 0.8) 0%, 
            rgba(118, 75, 162, 0.6) 50%, 
            rgba(240, 147, 251, 0.8) 100%
          );
        }

        &::after {
          opacity: 1;
        }
      }

      header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 2rem;
        margin-top: 0.5rem;

        svg {
          filter: drop-shadow(0 0 10px rgba(102, 126, 234, 0.5));
        }

        .project-links{
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        a > img {
          width: 5.0rem;
        }

        .private-badge {
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
          border: 1px solid rgba(102, 126, 234, 0.3);
          padding: 0.5rem 1.2rem;
          border-radius: 2rem;
          font-size: 1.1rem;
          color: #b8b8ff;
          backdrop-filter: blur(10px);
        }
      }
      
      h3{
        margin-bottom: 1.5rem;
        font-size: 1.9rem;
        font-weight: 700;
        background: linear-gradient(135deg, #ffffff 0%, #b8b8ff 50%, #f093fb 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        text-shadow: 0 0 30px rgba(240, 147, 251, 0.3);
      }

      p{
        letter-spacing: 0.08rem;
        margin-bottom: 1.5rem;
        color: #d0d0d0;
        font-size: 1.4rem;
        line-height: 1.8;

        a{
          color: #b8b8ff;
          border-bottom: 1px solid #764ba2;
          transition: color 0.25s;
          &:hover{
            color: #f093fb;
          }
        }
      }

      .role-section {
        background: linear-gradient(135deg, 
          rgba(102, 126, 234, 0.1) 0%, 
          rgba(118, 75, 162, 0.08) 100%
        );
        border-left: 3px solid transparent;
        border-image: linear-gradient(180deg, #667eea, #f093fb) 1;
        padding: 1.2rem 1.5rem;
        border-radius: 0 1rem 1rem 0;
        margin-bottom: 1.5rem;
        font-size: 1.3rem;
        color: #c0c0c0;
        line-height: 1.7;
        position: relative;

        strong {
          background: linear-gradient(135deg, #f093fb 0%, #667eea 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-weight: 600;
        }
      }

      footer{
        margin-top: auto;
        padding-top: 1rem;
        
        .tech-list{
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 0.8rem;
          font-size: 1.1rem;
          
          li {
            background: linear-gradient(135deg, 
              rgba(102, 126, 234, 0.15) 0%, 
              rgba(118, 75, 162, 0.15) 100%
            );
            border: 1px solid rgba(102, 126, 234, 0.25);
            padding: 0.5rem 1rem;
            border-radius: 2rem;
            color: #b8b8ff;
            font-weight: 500;
            transition: all 0.3s ease;
            
            &:hover {
              background: linear-gradient(135deg, 
                rgba(102, 126, 234, 0.3) 0%, 
                rgba(240, 147, 251, 0.3) 100%
              );
              transform: translateY(-2px);
              box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
            }
          }
        }
      }

    }
  }

  .more-projects {
    margin-top: 4rem;
    padding: 4rem;
    background: linear-gradient(145deg, 
      rgba(26, 26, 46, 0.9) 0%, 
      rgba(102, 126, 234, 0.08) 50%,
      rgba(22, 33, 62, 0.9) 100%
    );
    border: 2px solid transparent;
    border-radius: 2.5rem;
    text-align: center;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 2.5rem;
      padding: 2px;
      background: linear-gradient(135deg, 
        rgba(102, 126, 234, 0.5) 0%, 
        rgba(118, 75, 162, 0.3) 50%, 
        rgba(240, 147, 251, 0.5) 100%
      );
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
      pointer-events: none;
    }

    .more-projects-content {
      .count {
        display: block;
        font-size: 5rem;
        font-weight: 800;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        margin-bottom: 0.5rem;
        text-shadow: 0 0 60px rgba(102, 126, 234, 0.5);
        animation: pulse-count 2s ease-in-out infinite;
      }

      @keyframes pulse-count {
        0%, 100% { transform: scale(1); }
        50% { transform: scale(1.05); }
      }

      .text {
        display: block;
        font-size: 2.2rem;
        color: #e0e0e0;
        margin-bottom: 1.5rem;
        font-weight: 500;
      }

      p {
        color: #b0b0b0;
        font-size: 1.5rem;
        max-width: 650px;
        margin: 0 auto 2.5rem;
        line-height: 1.7;
      }

      .view-all-btn {
        display: inline-flex;
        align-items: center;
        gap: 1rem;
        padding: 1.4rem 3rem;
        background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
        border-radius: 3rem;
        color: white;
        font-size: 1.5rem;
        font-weight: 600;
        text-decoration: none;
        transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 8px 25px rgba(102, 126, 234, 0.35);
        position: relative;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          transition: left 0.5s ease;
        }

        img {
          width: 2.2rem;
          height: 2.2rem;
          filter: brightness(0) invert(1);
        }

        &:hover {
          transform: translateY(-5px) scale(1.05);
          box-shadow: 
            0 20px 40px rgba(102, 126, 234, 0.5),
            0 0 60px rgba(240, 147, 251, 0.3);
          
          &::before {
            left: 100%;
          }
        }
      }
    }
  }

  @media (max-width: 960px){
    .projects{
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 740px){
    .projects{
      grid-template-columns: 1fr;
    }

    .more-projects {
      padding: 2rem;

      .more-projects-content {
        .count {
          font-size: 3rem;
        }

        .text {
          font-size: 1.6rem;
        }
      }
    }
  }
`